import React from 'react'
import { SimpleFooter } from '../../footer/Footer'
import { AdminHeader } from '../plans/AdminHeader'
import { LastSessionAdminSection } from "./LastSessionAdminSection";
/**
 * Creado por Equilibrio Agency 2022<br>
 * Página para mostrar contenido de sección usuarios
 * @return {HTMLElement} Elementos HTML de cada componente
 * @interface AdminHeader
 */
export const LastSessionAdminPage = () => {
  return (
    <>
      <AdminHeader />
      <div style={{marginTop: "100px"}}></div>
      <LastSessionAdminSection></LastSessionAdminSection>
      <SimpleFooter></SimpleFooter>
    </>
  )
}
